import { Component  } from "react";
import HomePage from "../Components/HomePage/HomePage";
import {traceView} from "../Components/Globals/Globals"
import AndroidSmartBanner from '../Components/Globals/AndroidSmartBanner';
import android_cdlp_logo from '../Assets/Logos croisade/logo-cdlp.png'

class HomePageView extends Component{
    constructor(props){
        super(props)

        traceView("HomePage")
    }

    render(){
        return(
            <>
                <AndroidSmartBanner 
                    appId="mobile.consulting.patrickm.cdlp"
                    appName="CDLP"
                    appAuthor="patrickm.consulting"
                    iconUrl={android_cdlp_logo}
                />
              <HomePage/>  
            </>
        )
    }
}

export default HomePageView;